const constants = {
  SOCKET_CONNECTING: 'SOCKET_CONNECTING',
  SOCKET_CONNECTED: 'SOCKET_CONNECTED',
  SOCKET_DISCONNECTED: 'SOCKET_DISCONNECTED',
  SOCKET_ACTION: 'SOCKET_ACTION',
};

export default constants;
